import React, { useContext, useEffect, useState } from 'react'
import { BsDownload, BsPencil } from 'react-icons/bs'
import { CiCircleQuestion } from 'react-icons/ci'
import { FaCaretDown, FaPrint } from 'react-icons/fa6'
import { FiRefreshCcw } from 'react-icons/fi'
import { IoSettingsOutline } from 'react-icons/io5'
import { Link, useLocation, useParams } from 'react-router-dom'
import { getGeneralLedgerDetails, profitLossReportList } from '_services/reportService/reportService'
import { CommonDateRange, CustomPagination, Heading } from 'components'
import moment from "moment";
import StorageService from 'utils/StorageServices';
import { utils } from 'helper'
import { UserContext } from 'context'

const GeneralLedgerDetails = () => {

  let runing_balance = 0;
  const { id } = useParams();
  const { generalLedgerDate, setGeneralLedgerDate } = useContext(UserContext);
  const [accountTransactionsData, setAccountTransactionsData] = useState({});
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const [selectedRange, setSelectedRange] = useState({
    startDate: generalLedgerDate?.startDate ? moment(generalLedgerDate?.startDate) : moment().startOf('month'),
    endDate: generalLedgerDate?.endDate ? moment(generalLedgerDate?.endDate) : moment().endOf('month'),
  });

  const itemsPerPage = 100;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 100,
    offset: 1,
  });

  useEffect(() => {
    if (id) {
      getAccountTransactionsList(id)
    }
  }, [id, filter , selectedRange])

  const getAccountTransactionsList = async (_id) => {
    setLoading(true)
    const payload = {
      ...filter,
      account_id: _id,
      company_id: StorageService.getCompanyId(),
      start_date: moment(selectedRange?.startDate).format("YYYY-MM-DD"),
      end_date: moment(selectedRange?.endDate).format("YYYY-MM-DD"),
    }
    try {
      const res = await getGeneralLedgerDetails(payload);
      if (res?.responseCode == 200) {
        setAccountTransactionsData(res?.data)
        setTotalItems(res?.data?.total_record);
        setLoading(false)
      } else {
        setLoading(false)
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      offset: 1,
    }));
  };

  const resetFunction = () => {
    const newStartDate = moment().startOf('month');
    const newEndDate = moment().endOf('month');

    setSelectedRange({
      startDate: newStartDate,
      endDate: newEndDate,
    });

    setFilter((s) => ({
      ...s,
      offset: 1,
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  return (
    <>
      <div className='__znDe_mainBx'>
        <div>
          <div className='panel-heading'>
            <h2><span>Account Transactions</span></h2>

            <div className='panel-ctrls report-control'>
              <div>
                <CommonDateRange
                  key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                  initialStartDate={selectedRange.startDate}
                  initialEndDate={selectedRange.endDate}
                  onApply={handleApply}
                />
              </div>

              {/* <div className="dropdown">
                <button className="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  This Year
                  <FaCaretDown />
                </button>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="#">Action</a></li>
                  <li><a className="dropdown-item" href="#">Another action</a></li>
                  <li><a className="dropdown-item" href="#">Something else here</a></li>
                </ul>
              </div> */}

              {/* <button className='__bxs_srBtn'>
                <IoSettingsOutline />
              </button> */}

              <button className='__bxs_srBtn'>
                <BsDownload />
              </button>

              {/* <button className='__bxs_srBtn'>
                <FaPrint />
              </button> */}

              {/* <button className='__bxs_srBtn'>
                <BsPencil />
              </button> */}

              <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
                <FiRefreshCcw />
              </button>
            </div>
          </div>
        </div>

        <div className='__hrlMain_dix'>
          <div className='voucher report-voucher  printable ng-table-reports __glDetailsBx'>
            <div className='__mainPanel'>
              <div className="panel panel-primary">
                <div className='panel-body '>
                  <div className='py-20 block-ui block-ui-anim-fade'>
                    <div className='clear-both text-center p-10'>
                      <div className="__hrlMx_head" >
                        <p>{accountTransactionsData?.company?.company ? accountTransactionsData?.company?.company : '-'}</p>
                        <h4>Account Transactions</h4>
                        <h5><span>Account</span> : {accountTransactionsData?.account?.name ? accountTransactionsData?.account?.name : '-'}</h5>
                        <h5> <span> From </span> {accountTransactionsData?.start_date ? utils.getDateByApiResponse(accountTransactionsData?.start_date) : ""} To {accountTransactionsData?.end_date ? utils.getDateByApiResponse(accountTransactionsData?.end_date) : ""} </h5>
                      </div>
                    </div>

                    <div className='clear-both'>
                      <div className='report-table w-100'>
                        <table className='table report-table w-100 table-hover ng-table'>
                          <thead>
                            <tr className='ng-table-sort-header'>
                              <th className='header text-left'>
                                <div className='ng-table-header'>
                                  <span>Date</span>
                                </div>
                              </th>

                              <th className='header text-left pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Account</span>
                                </div>
                              </th>

                              <th className='header text-left pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Relation</span>
                                </div>
                              </th>

                              <th className='header text-left pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Expense Category</span>
                                </div>
                              </th>

                              <th className='header text-left pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Transaction Type</span>
                                </div>
                              </th>

                              <th className='header text-left pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Transaction#</span>
                                </div>
                              </th>

                              <th className='header text-left pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Reference#</span>
                                </div>
                              </th>

                              <th className='header text-end pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Debit (₹) <span style={{ fontSize: '15px' }}><CiCircleQuestion /></span></span>
                                </div>
                              </th>

                              <th className='header text-end pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Credit (₹) <span style={{ fontSize: '15px' }}><CiCircleQuestion /></span></span>
                                </div>
                              </th>

                              <th className='header text-end pr-important-10'>
                                <div className='ng-table-header'>
                                  <span>Amount (₹) <span style={{ fontSize: '15px' }}><CiCircleQuestion /></span></span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          
                          <tbody>
                            {accountTransactionsData?.list?.length > 0 ?
                              accountTransactionsData?.list?.map((el, ind) => {
                                runing_balance += el?.entries?.debit_amount - el?.entries?.credit_amount;
                                return (
                                  <>
                                    <tr className='ledger in ledgers cursor-pointer' key={ind}>
                                      <td className='text-left'>{!el?.entries?.account?.name ? 'As on' : ''} {el?.date ? utils.getDateByApiResponse(el?.date) : '-'}</td>
                                      <td className='text-left'>{el?.entries?.account?.name ? el?.entries?.account?.name : el?.description}</td>
                                      <td className='text-left'> {el?.vendor_detail?.name ? el?.vendor_detail?.name : '-'} </td>
                                      <td className='text-left'> {el?.voucher_id?.category_type === 1 ? el?.voucher_id?.categories[0]?.category?.name : (el?.voucher_id?.category_type === 2 ? el?.voucher_id?.category_name : '')} </td>
                                      <td className='text-left'> {el?.sub_type_name ? el?.sub_type_name : el?.type_name} </td>
                                      <td className='text-left'>{el?.transaction_no ? el?.transaction_no : '-'}</td>
                                      <td className='text-left'> <Link to={`/trip/addtrip/dispatched/${el?.trip?._id}`}> {el?.trip?.trip_number ? el?.trip?.trip_number : '-'} </Link> </td>
                                      <td className='text-end'>{el?.entries?.debit_amount ? (el?.entries?.debit_amount)?.toFixed(2) : '0.00'}</td>
                                      <td className='text-end'>{el?.entries?.credit_amount ? (el?.entries?.credit_amount)?.toFixed(2) : '0.00'}</td>
                                      <td className='text-end'>
                                        {runing_balance ? (runing_balance)?.toFixed(2) : 0}
                                      </td>
                                    </tr>
                                  </>
                                )
                              })
                              :
                              <tr className='ledger in ledgers cursor-pointer'>
                                <td className='text-left'> No transactions found </td>
                                <td className='text-left'></td>
                                <td className='text-left'></td>
                                <td className='text-left'></td>
                                <td className='text-left'></td>
                                <td className='text-left'></td>
                                <td className='text-left'></td>
                                <td className='text-left'></td>
                                <td className='text-left'></td>
                                <td className='text-left'></td>
                              </tr>
                            }
                            {/* <tr className='ledger in ledgers cursor-pointer'>
                              <td className='text-left'>As On 01/02/2025</td>
                              <td className='text-left' colSpan={5}>Opening Balance</td>
                              <td className='text-end'></td>
                              <td className='text-end'>₹0.00</td>
                              <td className='text-end'></td>
                            </tr>

                            <tr className='ledger in ledgers cursor-pointer'>
                              <td className='text-left'>06/02/2025</td>
                              <td className='text-left'>Labor</td>
                              <td className='text-left'>Advance Tax</td>
                              <td className='text-left'>Expense</td>
                              <td className='text-left'></td>
                              <td className='text-left'></td>
                              <td className='text-end'><Link to='#'>8,000.00</Link></td>
                              <td className='text-end'></td>
                              <td className='text-end'><Link to='#'>8,000.00 Dr</Link></td>
                            </tr>

                            <tr className='ledger in ledgers cursor-pointer'>
                              <td className='text-left'></td>
                              <td className='text-left' colSpan={5}>Total Debits and Credits (01/02/2025 - 28/02/2025)</td>
                              <td className='text-end'>₹8000.00</td>
                              <td className='text-end'>₹0.00</td>
                              <td className='text-end'></td>
                            </tr>

                            <tr className='ledger in ledgers cursor-pointer'>
                              <td className='text-left'>As On 28/02/2025</td>
                              <td className='text-left' colSpan={5}>Closing Balance</td>
                              <td className='text-end'>₹8000.00</td>
                              <td className='text-end'></td>
                              <td className='text-end'></td>
                            </tr> */}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {accountTransactionsData?.list?.length > 0 && <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div>}

      </div>
    </>
  )
}

export default GeneralLedgerDetails